<main
  class="agent-builder-flow"
  [class.agent-builder-flow--create]="!isEditShell()"
  [class.agent-builder-flow--edit]="isEditShell()"
  [class.agent-builder-flow--embedded]="isEmbeddedEdit()"
>
  @if (isEditShell() && !isEmbeddedEdit()) {
    <header class="agent-detail-header">
    <button type="button" appButton variant="ghost" size="sm" class="detail-back" (click)="back()" aria-label="Voltar para agentes">
        <ng-icon name="heroArrowLeft" size="14" aria-hidden="true" />
        Agentes
      </button>

      @if (store.loading() && !store.selectedAgent()) {
        <div class="agent-title-line">
          <app-ui-skeleton-row [height]="45" width="2.8rem" aria-hidden="true" />
          <app-ui-skeleton-row [height]="22" width="12rem" aria-hidden="true" />
        </div>
      } @else {
        <div class="agent-title-line">
          <span class="agent-title-icon" aria-hidden="true">
            <ng-icon name="heroCpuChip" size="22" />
          </span>
          <div class="agent-title-text">
            <h1>{{ store.selectedAgent()?.name || store.agentName() || 'Agente' }}</h1>
            <p class="agent-subtitle">
              {{ store.selectedArchetype()?.name || 'Agente configurado' }}
              @if (store.currentVersion()) {
                · versão atual v{{ store.currentVersion()?.version }}
              } @else {
                · sem versão publicada
              }
            </p>
          </div>
          <div class="agent-title-actions">
            <span appBadge tone="neutral" size="sm">
              @if (store.saving() || store.savingExit()) {
                Salvando
              } @else if (store.deploymentDirty() || store.triggerDirty()) {
                Deployment alterado
              } @else if (store.agentDirty() || store.versionDirty()) {
                Rascunho alterado
              } @else {
                Salvo
              }
            </span>
            <span appBadge [tone]="store.selectedChannelAccounts().length ? 'accent' : 'neutral'" size="sm">
              {{ store.selectedChannelAccounts().length }} deployment(s)
            </span>
            <button appButton variant="ghost" size="sm" type="button" (click)="reloadEditAgent()">
              <ng-icon name="heroArrowPath" size="14" aria-hidden="true" />
              Atualizar
            </button>
          </div>
        </div>
      }
    </header>

    <nav appRouteTabs aria-label="Seções do agente">
      @for (tab of editTabs(); track tab.id) {
        @if (tab.path; as path) {
          <a appRouteTabLink [routerLink]="path" [attr.aria-current]="activeEditTab() === tab.id ? 'page' : null">
            <ng-icon [name]="tab.icon" size="14" aria-hidden="true" />
            {{ tab.label }}
          </a>
        }
      }
    </nav>
  }
  @if (isEditShell()) {
  <header class="builder-topbar" aria-label="Navegação do Agent Builder">
    <button
      appButton
      class="back-button"
      variant="secondary"
      type="button"
      (click)="back()"
      aria-label="Voltar para agentes"
    >
      <ng-icon name="heroArrowLeft" size="16" aria-hidden="true" />
    </button>

    <nav appUiStepNav [attr.aria-label]="isEmbeddedEdit() ? 'Subseções da aba' : isEditShell() ? 'Seções do agente' : 'Etapas do construtor'">
      @if (isEmbeddedEdit() && activeEditTab() === 'configuracao') {
        @for (stepId of configStepIds; track stepId) {
          <button
            appUiStepPill
            type="button"
            [active]="store.activeStep() === stepId"
            [attr.aria-current]="store.activeStep() === stepId ? 'step' : null"
            (click)="store.goToEditStep(stepId)"
          >
            <span appUiStepPillLabel>{{ configStepLabel(stepId) }}</span>
          </button>
        }
      } @else if (isEmbeddedEdit() && activeEditTab() === 'missao') {
        <button appUiStepPill active type="button" aria-current="step">
          <ng-icon name="heroDocumentText" size="14" aria-hidden="true" />
          <span appUiStepPillLabel>Missão</span>
        </button>
      } @else if (isEditShell()) {
        @for (tab of editTabs(); track tab.id) {
          <button
            appUiStepPill
            type="button"
            [active]="activeEditTab() === tab.id"
            [attr.aria-current]="activeEditTab() === tab.id ? 'page' : null"
            (click)="goToEditTab(tab.id)"
          >
            <ng-icon [name]="tab.icon" size="14" aria-hidden="true" />
            <span appUiStepPillLabel>{{ tab.label }}</span>
          </button>
        }
      } @else {
        @for (step of store.steps; track step.id) {
          <button
            appUiStepPill
            type="button"
            [active]="store.activeStep() === step.id"
            [complete]="store.stepState(step.id) === 'complete'"
            [disabled]="store.stepState(step.id) === 'disabled'"
            [attr.aria-current]="store.activeStep() === step.id ? 'step' : null"
            (click)="store.goToStep(step.id)"
          >
            <span appUiStepPillLabel>{{ step.label }}</span>
          </button>
        }
      }
    </nav>

    <div class="top-actions">
      <span appBadge tone="neutral" size="sm">
        @if (store.saving() || store.savingExit()) {
          Salvando
        } @else if (store.dirty()) {
          Rascunho alterado
        } @else {
          Rascunho salvo
        }
      </span>
      @if (isEmbeddedEdit() && activeEditTab() === 'missao') {
        <button appButton variant="secondary" type="button" (click)="saveDraft()" [disabled]="store.saving()">
          Salvar rascunho
        </button>
        <button appButton variant="primary" type="button" (click)="store.publish()" [disabled]="!store.canPublish()">
          <ng-icon name="heroRocketLaunch" size="16" aria-hidden="true" />
          Publicar versão
        </button>
      } @else {
        <button
          appButton
          variant="primary"
          type="button"
          (click)="saveDraft()"
          [disabled]="
            store.saving() ||
            activeEditTab() === 'deployments' ||
            (store.activeStep() === 'context' && !store.canContinue())
          "
        >
          Salvar
        </button>
      }
    </div>
  </header>
  }

  @if (!isEditShell()) {
    <header class="create-builder-header">
      <button
        type="button"
        appButton
        variant="ghost"
        size="sm"
        class="create-builder-header__back"
        (click)="back()"
        aria-label="Voltar para agentes"
      >
        <ng-icon name="heroArrowLeft" size="15" aria-hidden="true" />
        <span>Agentes</span>
      </button>

      <div class="create-builder-progress" aria-live="polite">
        <div class="create-builder-progress__copy">
          <strong>{{ store.activeStep() === 'mission' ? 'Missão e lançamento' : assistantStageLabel() }}</strong>
          <span>
            {{ store.activeStep() === 'mission' ? 'Configuração concluída' : 'Etapa ' + (assistantStageIndex() + 1) + ' de ' + assistantStages.length }}
          </span>
        </div>
        <span class="create-builder-progress__track" aria-hidden="true">
          <span [style.width.%]="assistantProgress()"></span>
        </span>
      </div>

      <div class="create-builder-header__actions">
        @if (store.activeStep() === 'mission') {
          <button appButton variant="secondary" size="sm" type="button" (click)="saveDraft()" [disabled]="store.saving()">
            Salvar
          </button>
          <button appButton variant="primary" size="sm" type="button" (click)="store.publish()" [disabled]="!store.canPublish()">
            <ng-icon name="heroRocketLaunch" size="15" aria-hidden="true" />
            Publicar e ativar
          </button>
        } @else {
          <span appBadge tone="neutral" size="sm">
            Rascunho
          </span>
        }
      </div>
    </header>
  }

  <section class="builder-canvas" aria-label="Construtor de agente">
    @if (store.loading()) {
      <div appUiPanelCard class="loading-card" aria-busy="true" aria-label="Carregando construtor">
        <app-ui-skeleton-row [height]="18" width="42%" />
        <app-ui-skeleton-row [height]="14" width="72%" />
        <app-ui-skeleton-row [height]="180" width="100%" />
      </div>
    } @else {
      @if (store.loadWarnings().length > 0) {
        <div appUiPanelCard class="builder-warning" role="status">
          <strong>Carregamento parcial</strong>
          <span>{{ store.loadWarnings().join(' ') }}</span>
        </div>
      }
      @if (isEditShell() && activeEditTab() === 'overview') {
        <section class="builder-scene builder-scene--keep-heading">
          <header class="scene-heading scene-heading--compact">
            <h1>{{ store.selectedAgent()?.name || 'Agente' }}</h1>
            <p>{{ store.intent() || 'Revise a configuração, versão e deployments deste agente.' }}</p>
          </header>

          <div class="overview-grid">
            <article appUiPanelCard class="surface-panel overview-panel">
              <app-ui-section-header
                label="Estado operacional"
                [help]="store.currentVersion() ? 'Versão atual v' + store.currentVersion()?.version : 'Sem versão publicada'"
              />
              <div class="overview-facts">
                <span appUiPanelCard>
                  <strong>{{ store.selectedArchetype()?.name || 'Objetivo manual' }}</strong>
                  <small>Especialização</small>
                </span>
                <span appUiPanelCard>
                  <strong>{{ store.selectedChannelAccounts().length }}</strong>
                  <small>conta(s) em deployment</small>
                </span>
                <span appUiPanelCard>
                  <strong>{{ store.publishedVersions().length }}</strong>
                  <small>versão(ões) publicadas</small>
                </span>
              </div>
            </article>

            <article appUiPanelCard class="surface-panel overview-panel">
              <app-ui-section-header
                label="Próximas ações"
                help="Deployments podem ser salvos sem publicar uma nova versão."
              />
              <div class="overview-actions">
                <button appButton variant="secondary" type="button" (click)="goToEditTab('configuracao')">
                  Configuração
                </button>
                <button appButton variant="secondary" type="button" (click)="goToEditTab('missao')">
                  Missão
                </button>
              </div>
            </article>
          </div>
        </section>
      } @else if (isEditShell() && activeEditTab() === 'versoes') {
        <section class="builder-scene builder-scene--keep-heading">
          <header class="scene-heading scene-heading--compact">
            <h1>Versões</h1>
            <p>Escolha versões publicadas para deployments fixos e acompanhe o rascunho atual.</p>
          </header>

          @if (store.versions().length === 0) {
            <div appUiPanelCard class="surface-panel version-empty-panel">
              <app-ui-empty-state
                icon="heroDocumentText"
                title="Nenhuma vers&atilde;o encontrada"
                description="Publique uma vers&atilde;o para fixar deployments e acompanhar altera&ccedil;&otilde;es."
              />
            </div>
          } @else {
            <app-ui-record-list class="version-list-panel">
              @for (version of store.versions(); track version.id) {
                <li
                  appUiRecordRow
                  [interactive]="false"
                  [selected]="version.id === store.selectedAgent()?.currentVersionId"
                  class="version-row"
                >
                  <span>
                    <strong>v{{ version.version }}</strong>
                    <small>{{ version.status }} · Política de modelos do arquétipo</small>
                  </span>
                  @if (version.id === store.selectedAgent()?.currentVersionId) {
                    <span appBadge tone="accent" size="xs">Atual</span>
                  } @else if (version.status === 'published') {
                    <span appBadge tone="neutral" size="xs">Publicada</span>
                  } @else {
                    <span appBadge tone="warning" size="xs">Rascunho</span>
                  }
                </li>
              }
            </app-ui-record-list>
          }
        </section>
      } @else if (isEditShell() && activeEditTab() === 'execucoes') {
        <section class="builder-scene builder-scene--keep-heading">
          <header class="scene-heading scene-heading--compact">
            <h1>Execuções</h1>
            <p>Histórico operacional resumido deste agente.</p>
          </header>

          <div appUiPanelCard class="surface-panel overview-panel">
            <app-ui-section-header
              label="Histórico"
              [help]="store.hasExecutionHistory() ? 'Há execuções registradas para este agente.' : 'Ainda não há execuções registradas.'"
            />
            <app-ui-empty-state
              icon="heroBolt"
              [title]="store.hasExecutionHistory() ? 'Execuções disponíveis' : 'Nenhuma execução registrada'"
              [description]="store.hasExecutionHistory() ? 'Use os filtros de execuções para investigar runs específicas.' : 'O agente ainda não executou conversas ou automações.'"
            />
          </div>
        </section>
      } @else {
        @if (isEditShell() && activeEditTab() === 'configuracao' && !isEmbeddedEdit()) {
          <nav appUiStepNav class="config-subnav" aria-label="Subseções de configuração">
            @for (stepId of configStepIds; track stepId) {
              <button
                appUiStepPill
                type="button"
                [active]="store.activeStep() === stepId"
                (click)="store.goToStep(stepId)"
              >
                <span appUiStepPillLabel>{{ configStepLabel(stepId) }}</span>
              </button>
            }
          </nav>
        }
      @switch (store.activeStep()) {
        @case ('context') {
          @if (!isEditShell()) {
            <section class="builder-scene builder-scene--wide assistant-scene assistant-scene--guided">
              <div class="assistant-workspace" aria-label="Criação assistida do agente">
                <div class="assistant-layout">
                  <div class="assistant-stage-shell">
                    @switch (assistantStage()) {
                      @case ('intent') {
                        <section class="assistant-stage assistant-stage--intent">
                          <div class="assistant-stage__copy">
                            <h1>Defina o trabalho do agente</h1>
                            <p>Descreva o resultado esperado, os limites e quando uma pessoa deve assumir.</p>
                          </div>

                          <div appUiPanelCard class="assistant-composer assistant-composer--briefing">
                            <textarea
                              appTextarea
                              rows="5"
                              [value]="store.assistantPrompt()"
                              (input)="store.setAssistantPrompt($event)"
                              placeholder="Ex.: qualificar leads do WhatsApp, consultar a base comercial, atualizar o CRM e transferir oportunidades quentes. Não confirmar condições fora da política comercial."
                              aria-label="Descreva o que o agente deve fazer"
                            ></textarea>
                            <div class="assistant-composer__footer">
                              <span>A configuração sugerida será revisável.</span>
                              <button appButton variant="primary" type="button" (click)="applyAssistantPrompt()" [disabled]="!store.assistantPrompt().trim()">
                                Montar configuração
                                <ng-icon name="heroArrowRight" size="16" aria-hidden="true" />
                              </button>
                            </div>
                          </div>

                          <details class="assistant-templates">
                            <summary>
                              <span>
                                <strong>Usar um modelo</strong>
                                <small>Aplicar papel e limites predefinidos.</small>
                              </span>
                              <ng-icon name="heroChevronDown" size="15" aria-hidden="true" />
                            </summary>
                            @if (assistantObjectives().length === 0) {
                              <div class="assistant-empty">Nenhum modelo está disponível. Use o briefing acima.</div>
                            } @else {
                              <div class="assistant-objective-grid">
                                @for (archetype of assistantObjectives(); track archetype.id) {
                                  <button
                                    type="button"
                                    appUiOptionRow
                                    class="assistant-objective"
                                    [selected]="store.selectedArchetypeId() === archetype.id"
                                    (click)="selectObjective(archetype)"
                                  >
                                    <span appUiOptionRowIcon aria-hidden="true">
                                      <ng-icon name="heroCpuChip" size="16" />
                                    </span>
                                    <span appUiOptionRowCopy>
                                      <strong>{{ archetype.name }}</strong>
                                      <small>{{ archetypeNorthStar(archetype) }}</small>
                                    </span>
                                    <span appUiOptionRowCheck aria-hidden="true">
                                      @if (store.selectedArchetypeId() === archetype.id) {
                                        <ng-icon name="heroCheck" size="13" />
                                      }
                                    </span>
                                  </button>
                                }
                              </div>
                            }
                          </details>
                        </section>
                      }

                      @case ('identity') {
                        <section class="assistant-stage">
                          <div class="assistant-stage__copy">
                            <h1>Papel e identidade</h1>
                            <p>Defina como o agente aparece para a equipe e se apresenta nas conversas.</p>
                          </div>

                          <div class="assistant-identity-form">
                            <div class="assistant-identity-fields">
                              <app-ui-form-field label="Nome interno" hint="Use um nome fácil de localizar e administrar.">
                                <input
                                  appInput
                                  type="text"
                                  [value]="store.agentName()"
                                  (input)="store.setString(store.agentName, $event)"
                                  placeholder="Ex.: Qualificador comercial"
                                />
                              </app-ui-form-field>
                              <app-ui-form-field label="Nome de apresentação" hint="Opcional. Como ele pode se apresentar ao cliente.">
                                <input
                                  appInput
                                  type="text"
                                  [value]="store.presentationName()"
                                  (input)="store.setString(store.presentationName, $event)"
                                  placeholder="Ex.: Ana"
                                />
                              </app-ui-form-field>
                            </div>

                            <app-ui-form-field label="Intenção operacional" hint="Descreva o papel, o limite e o resultado esperado.">
                              <textarea
                                appTextarea
                                rows="4"
                                [value]="store.intent()"
                                (input)="store.setString(store.intent, $event)"
                                placeholder="Ex.: entender a necessidade, consultar informações confiáveis e encaminhar exceções para o time comercial."
                              ></textarea>
                            </app-ui-form-field>

                          </div>

                          <div class="assistant-stage__actions">
                            <button appButton variant="ghost" size="sm" type="button" (click)="backAssistantStage()">Voltar</button>
                            <span>Nome e intenção são obrigatórios</span>
                            <button
                              appButton
                              variant="primary"
                              type="button"
                              (click)="confirmAssistantIdentity()"
                              [disabled]="!store.agentName().trim() || !store.intent().trim()"
                            >
                              Continuar
                            </button>
                          </div>
                        </section>
                      }

                      @case ('libraries') {
                        <section class="assistant-stage">
                          <div class="assistant-stage__copy">
                            <h1>Conhecimento</h1>
                            <p>Escolha as fontes que o agente pode consultar.</p>
                          </div>

                          @if (assistantKnowledgeBases().length === 0) {
                            <div class="assistant-empty">Nenhuma biblioteca ativa foi encontrada. Você pode seguir sem contexto externo.</div>
                          } @else {
                            <div class="assistant-chip-grid">
                              @for (base of assistantKnowledgeBases(); track base.id) {
                                <button
                                  type="button"
                                  appUiOptionRow
                                  class="assistant-chip"
                                  [selected]="store.isSelected(store.selectedKnowledgeBaseIds(), base.id)"
                                  (click)="store.toggleKnowledgeBase(base.id)"
                                >
                                  <span appUiOptionRowIcon aria-hidden="true">
                                    <ng-icon name="heroDocumentText" size="16" />
                                  </span>
                                  <span appUiOptionRowCopy>
                                    <strong>{{ base.name }}</strong>
                                    <small>{{ store.knowledgeTypeLabel(base.type) }} · {{ base.activeDocumentCount || 0 }} docs</small>
                                  </span>
                                  <span appUiOptionRowCheck aria-hidden="true">
                                    @if (store.isSelected(store.selectedKnowledgeBaseIds(), base.id)) {
                                      <ng-icon name="heroCheck" size="13" />
                                    }
                                  </span>
                                </button>
                              }
                            </div>
                          }

                          <div class="assistant-stage__actions">
                            <button appButton variant="ghost" size="sm" type="button" (click)="backAssistantStage()">Voltar</button>
                            <span>{{ store.selectedKnowledgeBases().length }} selecionada(s)</span>
                            <button appButton variant="ghost" size="sm" type="button" (click)="skipAssistantLibraries()">Seguir sem biblioteca</button>
                            <button appButton variant="primary" type="button" (click)="confirmAssistantLibraries()" [disabled]="store.selectedKnowledgeBases().length === 0">
                              Continuar
                            </button>
                          </div>
                        </section>
                      }

                      @case ('actions') {
                        <section class="assistant-stage">
                          <div class="assistant-stage__copy">
                            <h1>Ações permitidas</h1>
                            <p>Habilite somente os sistemas e ações necessários para este papel.</p>
                          </div>

                          <div class="assistant-actions-layout">
                            <div class="assistant-actions-catalog">
                            @if (assistantIntegrations().length > 0) {
                              <div class="assistant-resource-group">
                              <div class="assistant-section-heading">
                                <strong>Integrações</strong>
                                <span>{{ store.selectedIntegrations().length }} selecionada(s)</span>
                              </div>
                              <div class="assistant-integration-list">
                                @for (integration of assistantIntegrations(); track integration.id) {
                                  <button
                                    type="button"
                                    appUiOptionRow
                                    class="assistant-integration"
                                    [selected]="store.isSelected(store.selectedIntegrationIds(), integration.id)"
                                    (click)="store.toggleIntegration(integration.id)"
                                  >
                                    <app-provider-brand-icon [entry]="providerEntryForIntegration(integration.provider)" [size]="1.4" />
                                    <span>
                                      <strong>{{ integration.displayName }}</strong>
                                      <small>{{ providerEntryForIntegration(integration.provider)?.name || integration.provider }}</small>
                                    </span>
                                    @if (store.isSelected(store.selectedIntegrationIds(), integration.id)) {
                                      <ng-icon name="heroCheck" size="16" aria-hidden="true" />
                                    }
                                  </button>
                                }
                              </div>
                              </div>
                            }

                            <div class="assistant-resource-group">
                              <div class="assistant-section-heading">
                                <strong>Capacidades</strong>
                                <span>{{ store.selectedTools().length + store.selectedSkills().length }} selecionada(s)</span>
                              </div>
                              <label class="assistant-tool-search">
                                <ng-icon name="heroMagnifyingGlass" size="15" aria-hidden="true" />
                                <input
                                  appInput
                                  type="search"
                                  placeholder="Buscar por ação, sistema ou domínio"
                                  [value]="store.toolSearch()"
                                  (input)="store.setString(store.toolSearch, $event)"
                                />
                              </label>
                            <div class="assistant-chip-grid assistant-chip-grid--compact">
                              @for (tool of assistantTools(); track tool.id) {
                              <button
                                type="button"
                                appUiOptionRow
                                class="assistant-chip"
                                [selected]="store.isSelected(store.selectedToolIds(), tool.id)"
                                (click)="selectAssistantTool(tool)"
                              >
                                <span appUiOptionRowIcon aria-hidden="true">
                                  <ng-icon name="heroWrenchScrewdriver" size="16" />
                                </span>
                                <span appUiOptionRowCopy>
                                  <strong>{{ tool.displayName || tool.key }}</strong>
                                  <small>{{ tool.owningDomain }} · {{ store.toolRiskLabel(tool.riskLevel) }}</small>
                                </span>
                                <span appUiOptionRowCheck aria-hidden="true">
                                  @if (store.isSelected(store.selectedToolIds(), tool.id)) {
                                    <ng-icon name="heroCheck" size="13" />
                                  }
                                </span>
                              </button>
                              }

                              @for (skill of assistantSkills(); track skill.id) {
                              <button
                                type="button"
                                appUiOptionRow
                                class="assistant-chip"
                                [selected]="store.isSelected(store.selectedSkillIds(), skill.id)"
                                [disabled]="!store.skillVersions()[skill.id]"
                                (click)="store.toggleSkill(skill)"
                              >
                                <span appUiOptionRowIcon aria-hidden="true">
                                  <ng-icon name="heroBolt" size="16" />
                                </span>
                                <span appUiOptionRowCopy>
                                  <strong>{{ skill.name }}</strong>
                                  <small>{{ skill.category || skill.integrationProviderKey || 'Skill' }}</small>
                                </span>
                                <span appUiOptionRowCheck aria-hidden="true">
                                  @if (store.isSelected(store.selectedSkillIds(), skill.id)) {
                                    <ng-icon name="heroCheck" size="13" />
                                  }
                                </span>
                              </button>
                              }
                            </div>
                            </div>
                            </div>

                            <aside class="assistant-tool-inspector" aria-label="Configuração da tool selecionada">
                              @if (assistantConfiguredToolIds().length > 0) {
                                <app-agent-tool-config-panel
                                  [compact]="true"
                                  [toolIds]="assistantConfiguredToolIds()"
                                />
                              } @else {
                                <div class="assistant-tool-inspector__empty">
                                  <ng-icon name="heroWrenchScrewdriver" size="18" aria-hidden="true" />
                                  <strong>Inspecione antes de liberar</strong>
                                  <p>Selecione uma tool para revisar campos de entrada, valores fixos e contrato de saída.</p>
                                </div>
                              }
                            </aside>
                          </div>

                          <div class="assistant-stage__actions">
                            <button appButton variant="ghost" size="sm" type="button" (click)="backAssistantStage()">Voltar</button>
                            <span>{{ store.selectedIntegrations().length + store.selectedTools().length + store.selectedSkills().length }} capacidade(s)</span>
                            <button appButton variant="ghost" size="sm" type="button" (click)="skipAssistantActions()">Seguir sem ações</button>
                            <button
                              appButton
                              variant="primary"
                              type="button"
                              (click)="confirmAssistantActions()"
                              [disabled]="store.selectedIntegrations().length + store.selectedTools().length + store.selectedSkills().length === 0"
                            >
                              Continuar
                            </button>
                          </div>
                        </section>
                      }

                      @case ('flow') {
                        <section class="assistant-stage">
                          <div class="assistant-stage__copy">
                            <h1>Tom e autonomia</h1>
                            <p>Escolha como o agente conversa e decide quando agir ou transferir.</p>
                          </div>

                          <div class="assistant-choice-group">
                            <div class="assistant-choice-group__label">
                              <strong>Tom de voz</strong>
                              <span>{{ store.toneLabel() }}</span>
                            </div>
                            <div class="assistant-flow-grid">
                              @for (option of store.toneOptions; track option.value) {
                                <button
                                  type="button"
                                  appUiOptionRow
                                  class="assistant-flow-choice"
                                  [selected]="store.tone() === option.value"
                                  (click)="store.setTone(option.value)"
                                >
                                  <span appUiOptionRowIcon aria-hidden="true">
                                    <ng-icon name="heroUserCircle" size="16" />
                                  </span>
                                  <span appUiOptionRowCopy>
                                    <strong>{{ option.label }}</strong>
                                    <small>{{ option.policy }}</small>
                                  </span>
                                  <span appUiOptionRowCheck aria-hidden="true">
                                    @if (store.tone() === option.value) {
                                      <ng-icon name="heroCheck" size="13" />
                                    }
                                  </span>
                                </button>
                              }
                            </div>
                          </div>

                          <div class="assistant-choice-group">
                            <div class="assistant-choice-group__label">
                              <strong>Nível de iniciativa</strong>
                              <span>{{ store.intensityLabel() }}</span>
                            </div>
                            <div class="assistant-flow-grid assistant-flow-grid--short">
                              @for (option of store.intensityOptions; track option.value) {
                                <button
                                  type="button"
                                  appUiOptionRow
                                  class="assistant-flow-choice"
                                  [selected]="store.intensity() === option.value"
                                  (click)="store.setIntensity(option.value)"
                                >
                                  <span appUiOptionRowIcon aria-hidden="true">
                                    <ng-icon name="heroBolt" size="16" />
                                  </span>
                                  <span appUiOptionRowCopy>
                                    <strong>{{ option.label }}</strong>
                                    <small>{{ option.policy }}</small>
                                  </span>
                                  <span appUiOptionRowCheck aria-hidden="true">
                                    @if (store.intensity() === option.value) {
                                      <ng-icon name="heroCheck" size="13" />
                                    }
                                  </span>
                                </button>
                              }
                            </div>
                          </div>

                          <div class="assistant-stage__actions">
                            <button appButton variant="ghost" size="sm" type="button" (click)="backAssistantStage()">Voltar</button>
                            <span>{{ store.assistantSummary().tone }} · {{ store.assistantSummary().intensity }}</span>
                            <button appButton variant="primary" type="button" (click)="confirmAssistantFlow()">Definir operação</button>
                          </div>
                        </section>
                      }

                      @case ('operation') {
                        <section class="assistant-stage">
                          <div class="assistant-stage__copy">
                            <h1>Canais e ativação</h1>
                            <p>Escolha onde o agente opera e em qual estado será publicado.</p>
                          </div>

                          <div class="assistant-operation">
                            <section class="assistant-operation__section">
                              <div class="assistant-operation__heading">
                                <span>
                                  <strong>Canais permitidos</strong>
                                  <small>Selecione os ambientes em que o agente poderá atuar.</small>
                                </span>
                                <span appBadge tone="neutral" size="xs">{{ store.selectedAllowedChannels().length }} selecionado(s)</span>
                              </div>
                              <div class="assistant-channel-grid" role="group" aria-label="Canais permitidos">
                                @for (channel of store.allowedChannelOptions; track channel.type) {
                                  <button
                                    type="button"
                                    appUiOptionRow
                                    class="assistant-channel-option"
                                    [selected]="store.isSelectedChannelType(channel.type)"
                                    (click)="store.toggleChannelType(channel.type)"
                                    [attr.aria-pressed]="store.isSelectedChannelType(channel.type)"
                                  >
                                    <img
                                      [ngSrc]="store.isSelectedChannelType(channel.type) ? channel.logoColorPath : channel.logoMonoPath"
                                      width="20"
                                      height="20"
                                      alt=""
                                    />
                                    <span>{{ channel.label }}</span>
                                    @if (store.isSelectedChannelType(channel.type)) {
                                      <ng-icon name="heroCheck" size="15" aria-hidden="true" />
                                    }
                                  </button>
                                }
                              </div>
                            </section>

                            <section class="assistant-operation__section">
                              <div class="assistant-operation__heading">
                                <span>
                                  <strong>Contas de atendimento</strong>
                                  <small>Apenas contas conectadas aos canais escolhidos aparecem aqui.</small>
                                </span>
                                <span appBadge [tone]="store.selectedChannelAccounts().length ? 'accent' : 'warning'" size="xs">
                                  {{ store.selectedChannelAccounts().length }} selecionada(s)
                                </span>
                              </div>
                              @if (store.selectedAllowedChannels().length === 0) {
                                <p appUiEmptyText>Escolha um canal para ver as contas disponíveis.</p>
                              } @else {
                                <div class="assistant-account-list">
                                  @for (channel of store.selectedAllowedChannels(); track channel.type) {
                                    @for (account of store.channelAccountsForType(channel.type); track account.id) {
                                      <button
                                        type="button"
                                        appUiOptionRow
                                        class="assistant-account-option"
                                        [selected]="store.isSelected(store.selectedChannelAccountIds(), account.id)"
                                        (click)="store.toggleChannelAccount(account.id)"
                                      >
                                        <img [ngSrc]="channel.logoColorPath" width="20" height="20" alt="" />
                                        <span appUiOptionRowCopy>
                                          <strong>{{ account.label }}</strong>
                                          <small>{{ channel.label }}</small>
                                        </span>
                                        <span appUiOptionRowCheck aria-hidden="true">
                                          @if (store.isSelected(store.selectedChannelAccountIds(), account.id)) {
                                            <ng-icon name="heroCheck" size="13" />
                                          }
                                        </span>
                                      </button>
                                    }
                                  }
                                </div>
                              }
                            </section>

                            <section class="assistant-operation__section assistant-operation__policy">
                              <div class="assistant-operation__heading">
                                <span>
                                  <strong>Política inicial</strong>
                                  <small>Defina como o agente começa. Isso pode ser alterado depois.</small>
                                </span>
                              </div>
                              <div class="assistant-policy-fields">
                                <label>
                                  <span>Modo de execução</span>
                                  <select appNativeSelect [value]="store.deploymentMode()" (change)="store.setDeploymentMode($any($event.target).value)">
                                    @for (option of store.deploymentModeOptions; track option.value) {
                                      <option [value]="option.value">{{ option.label }}</option>
                                    }
                                  </select>
                                  <small>{{ deploymentModeDetail() }}</small>
                                </label>
                                <label>
                                  <span>Estado após publicar</span>
                                  <select appNativeSelect [value]="store.deploymentStatus()" (change)="store.setDeploymentStatus($any($event.target).value)">
                                    @for (option of store.deploymentStatusOptions; track option.value) {
                                      <option [value]="option.value">{{ option.label }}</option>
                                    }
                                  </select>
                                  <small>{{ deploymentStatusDetail() }}</small>
                                </label>
                              </div>
                            </section>

                            @if (store.selectedChannelAccounts().length > 0) {
                              <details class="assistant-advanced">
                                <summary>
                                  <span>
                                    <strong>Limites por conta</strong>
                                    <small>Restringir atendimento por segmento.</small>
                                  </span>
                                  <ng-icon name="heroChevronDown" size="15" aria-hidden="true" />
                                </summary>
                                <div class="assistant-account-policies">
                                  @for (account of store.selectedChannelAccounts(); track account.id) {
                                    <label>
                                      <span>{{ account.label }}</span>
                                      <select appNativeSelect [value]="store.deploymentSegmentForAccount(account.id)" (change)="store.setDeploymentSegmentForAccount(account.id, $any($event.target).value)">
                                        <option value="">Atender todos os contatos</option>
                                        @for (segment of store.contactSegments(); track segment.id) {
                                          <option [value]="segment.id">Somente {{ segment.name }}</option>
                                        }
                                      </select>
                                    </label>
                                  }
                                </div>
                              </details>
                            }
                          </div>

                          <div class="assistant-stage__actions">
                            <button appButton variant="ghost" size="sm" type="button" (click)="backAssistantStage()">Voltar</button>
                            <span>{{ store.selectedChannelAccounts().length ? store.selectedChannelAccounts().length + ' conta(s) pronta(s)' : 'Você pode configurar contas depois' }}</span>
                            <button appButton variant="primary" type="button" (click)="confirmAssistantOperation()">Revisar lançamento</button>
                          </div>
                        </section>
                      }

                      @case ('review') {
                        <section class="assistant-stage assistant-stage--review">
                          <div class="assistant-stage__copy">
                            <h1>Revisar configuração</h1>
                            <p>Confirme as escolhas antes de gerar a missão do agente.</p>
                          </div>

                          <div class="assistant-review-list">
                            <div>
                              <span>Identidade</span>
                              <strong>{{ store.agentName() }}</strong>
                              <small>{{ store.presentationName() || 'Sem nome de apresentação' }}</small>
                            </div>
                            <div>
                              <span>Objetivo</span>
                              <strong>{{ store.assistantSummary().objective }}</strong>
                              <small>{{ store.assistantSummary().intent }}</small>
                            </div>
                            <div>
                              <span>Recursos</span>
                              <strong>{{ store.assistantSummary().libraries }} biblioteca(s) · {{ store.assistantSummary().capabilities }} capacidade(s)</strong>
                              <small>{{ store.selectedAllowedChannels().length }} canal(is) permitido(s)</small>
                            </div>
                            <div>
                              <span>Conversa</span>
                              <strong>{{ store.assistantSummary().tone }} · {{ store.assistantSummary().intensity }}</strong>
                              <small>Políticas detalhadas continuam disponíveis no editor avançado.</small>
                            </div>
                            <div>
                              <span>Operação</span>
                              <strong>{{ store.selectedChannelAccounts().length }} conta(s) · {{ store.deploymentModeLabel() }}</strong>
                              <small>{{ store.deploymentStatusLabel() }} após a publicação.</small>
                            </div>
                          </div>

                          <div class="assistant-stage__actions">
                            <button appButton variant="ghost" size="sm" type="button" (click)="backAssistantStage()">Voltar</button>
                            <span>A próxima tela é a revisão final da missão</span>
                            <button
                              appButton
                              variant="primary"
                              type="button"
                              (click)="generateAssistedMission()"
                              [disabled]="!assistantCanGenerate()"
                            >
                              @if (store.saving() || store.missionRunStatus() === 'queued' || store.missionRunStatus() === 'running') {
                                Gerando missão...
                              } @else {
                                <ng-icon name="heroDocumentText" size="16" aria-hidden="true" />
                                Gerar missão
                              }
                            </button>
                          </div>
                        </section>
                      }
                    }
                  </div>

                </div>
              </div>
            </section>
          } @else {
          <section class="builder-scene">
            <header class="scene-heading scene-heading--compact">
              <h1>Contexto</h1>
              <p>Objetivo inicial e canais onde o agente pode existir.</p>
            </header>

            <div appUiPanelCard class="surface-panel context-panel">
              <app-ui-section-header
                label="Objetivo"
                help="Escolha o ponto de partida. As próximas etapas usam esse contexto para gerar a missão inicial."
              />
              <div class="objective-grid">
                @if (store.archetypes().length === 0) {
                  <app-ui-empty-state
                    class="col-span-full"
                    icon="heroCpuChip"
                    title="Objetivos n&atilde;o carregados"
                    description="Descreva livremente; os objetivos cadastrados n&atilde;o foram carregados agora."
                  />
                } @else {
                  @for (archetype of store.archetypes(); track archetype.id) {
                    <button
                      type="button"
                      appUiOptionRow
                      class="choice-card choice-card--objective"
                      [selected]="store.selectedArchetypeId() === archetype.id"
                      (click)="selectObjective(archetype)"
                      [disabled]="store.saving()"
                      [attr.aria-label]="'Selecionar objetivo ' + archetype.name"
                    >
                      <span appUiOptionRowIcon aria-hidden="true">
                        <ng-icon name="heroCpuChip" size="16" />
                      </span>
                      <span appUiOptionRowCopy class="choice-card__body">
                        <span class="choice-card__title">
                          <strong>{{ archetype.name }}</strong>
                        </span>
                        <small>{{ archetypeNorthStar(archetype) }}</small>
                      </span>
                      <span appUiOptionRowCheck aria-hidden="true">
                        @if (store.selectedArchetypeId() === archetype.id) {
                          <ng-icon name="heroCheck" size="13" />
                        }
                      </span>
                    </button>
                  }
                }
              </div>

              <app-ui-section-header
                label="Canais"
                help="Marque os canais permitidos. Modo de execução e contas entram em Deployments."
              />
              <div class="channel-picker" role="group" aria-label="Canais permitidos">
                @for (channel of store.allowedChannelOptions; track channel.type) {
                  <button
                    type="button"
                    appUiOptionRow
                    class="channel-option"
                    [selected]="store.isSelectedChannelType(channel.type)"
                    [style.--channel-color]="channel.brandColor"
                    (click)="store.toggleChannelType(channel.type)"
                    [attr.aria-pressed]="store.isSelectedChannelType(channel.type)"
                  >
                    <span class="channel-card__brand" aria-hidden="true">
                      <img
                        [ngSrc]="
                          store.isSelectedChannelType(channel.type)
                            ? channel.logoColorPath
                            : channel.logoMonoPath
                        "
                        width="22"
                        height="22"
                        alt=""
                      />
                    </span>
                    <span class="channel-option__copy">
                      <strong>{{ channel.label }}</strong>
                      <small>{{ store.channelAccountCountForType(channel.type) }} conta(s)</small>
                    </span>
                    @if (store.isSelectedChannelType(channel.type)) {
                      <ng-icon name="heroCheck" size="16" aria-hidden="true" />
                    }
                  </button>
                }
              </div>
            </div>
          </section>
          }
        }

        @case ('persona') {
          <section class="builder-scene">
            <header class="scene-heading scene-heading--compact">
              <h1>Persona</h1>
              <p>Identidade, tom e calibração de resposta.</p>
            </header>

            <div class="persona-layout">
              <div appUiPanelCard class="surface-panel persona-identity">
                <app-ui-section-header
                  label="Identidade"
                  help="Esses campos entram como insumo direto na geração da missão."
                />
                <app-ui-form-field
                  label="Nome de apresentação"
                  hint="Como o agente pode se apresentar para clientes."
                >
                  <input
                    appInput
                    type="text"
                    [value]="store.presentationName()"
                    (input)="store.setString(store.presentationName, $event)"
                    placeholder="Ex.: Ana"
                  />
                </app-ui-form-field>
                <app-ui-form-field
                  label="Intenção operacional"
                  hint="Explique o papel, limite e resultado esperado da conversa."
                >
                  <textarea
                    appTextarea
                    rows="5"
                    [value]="store.intent()"
                    (input)="store.setString(store.intent, $event)"
                    placeholder="Ex.: qualificar leads, consultar catálogo, abrir oportunidade e transferir exceções para o time comercial."
                  ></textarea>
                </app-ui-form-field>
              </div>

              <div appUiPanelCard class="surface-panel persona-options">
                <app-ui-section-header
                  label="Comportamento"
                  [help]="store.toneLabel() + ' · ' + store.intensityLabel()"
                />
                <div class="option-stack" role="group" aria-label="Tom de resposta">
                  @for (option of store.toneOptions; track option.value) {
                    <button
                      type="button"
                      appUiOptionRow
                      class="choice-card choice-card--compact"
                      [selected]="store.tone() === option.value"
                      (click)="store.setTone(option.value)"
                    >
                      <span class="choice-card__icon">
                        <ng-icon name="heroUserCircle" size="17" aria-hidden="true" />
                      </span>
                      <span>
                        <strong>{{ option.label }}</strong>
                        <small>{{ option.policy }}</small>
                      </span>
                    </button>
                  }
                </div>

                <div class="calibration-stack" aria-label="Calibração de comportamento">
                  <label appUiPanelCard class="calibration-control">
                    <span>
                      <strong>Detalhamento</strong>
                      <small>{{ store.messageLengthLabel(store.responseLength()) }}</small>
                    </span>
                    <input
                      appUiRange
                      type="range"
                      min="0"
                      max="2"
                      step="1"
                      [value]="store.responseLengthScale()"
                      (input)="store.setResponseLengthFromRange($event)"
                      aria-label="Detalhamento da resposta"
                    />
                    <span class="calibration-control__ticks" aria-hidden="true">
                      <small>Curta</small>
                      <small>Normal</small>
                      <small>Detalhada</small>
                    </span>
                  </label>

                  <label appUiPanelCard class="calibration-control">
                    <span>
                      <strong>Autonomia</strong>
                      <small>{{ store.intensityLabel() }}</small>
                    </span>
                    <input
                      appUiRange
                      type="range"
                      min="0"
                      max="2"
                      step="1"
                      [value]="store.intensityScale()"
                      (input)="store.setIntensityFromRange($event)"
                      aria-label="Autonomia do agente"
                    />
                    <span class="calibration-control__ticks" aria-hidden="true">
                      <small>Cautelosa</small>
                      <small>Equilibrada</small>
                      <small>Proativa</small>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </section>
        }

        @case ('libraries') {
          <section class="builder-scene builder-scene--keep-heading">
            <header class="scene-heading scene-heading--compact">
              <h1>Bibliotecas</h1>
              <p>Allowlist de Knowledge.</p>
            </header>

            <div appUiPanelCard class="surface-panel">
              <div class="catalog-toolbar">
                <label class="search-field">
                  <ng-icon name="heroMagnifyingGlass" size="16" aria-hidden="true" />
                  <input
                    appInput
                    type="search"
                    placeholder="Filtrar bibliotecas"
                    [value]="store.librarySearch()"
                    (input)="store.setString(store.librarySearch, $event)"
                  />
                </label>
                <button
                  appSelect
                  type="button"
                  [ngpSelectValue]="store.libraryTypeFilter()"
                  (ngpSelectValueChange)="store.setLibraryTypeFilter($event)"
                >
                  {{ store.libraryTypeFilterLabel() }}
                  <div *ngpSelectPortal appSelectDropdown>
                    @for (option of store.knowledgeTypeOptions(); track option.value) {
                      <div appSelectOption [ngpSelectOptionValue]="option.value">
                        {{ option.label }}
                      </div>
                    }
                  </div>
                </button>
                <span appBadge tone="accent" size="sm">{{ selectedLibraryLabel() }}</span>
              </div>

              <div class="resource-grid">
                @if (store.visibleKnowledgeBases().length === 0) {
                  <app-ui-empty-state
                    class="col-span-full"
                    icon="heroDocumentText"
                    title="Nenhuma biblioteca encontrada"
                    description="Ajuste os filtros ou siga sem contexto externo nesta etapa."
                  />
                } @else {
                  @for (base of store.visibleKnowledgeBases(); track base.id) {
                    <button
                      type="button"
                      appUiOptionRow
                      class="resource-card"
                      [selected]="
                        store.isSelected(store.selectedKnowledgeBaseIds(), base.id)
                      "
                      (click)="store.toggleKnowledgeBase(base.id)"
                    >
                      <span class="resource-card__top">
                        <strong>{{ base.name }}</strong>
                        <span appBadge tone="neutral" size="xs">@</span>
                      </span>
                      <small
                        >{{ store.knowledgeTypeLabel(base.type) }} ·
                        {{ base.activeDocumentCount || 0 }} documentos ativos</small
                      >
                      @if (base.description) {
                        <p>{{ base.description }}</p>
                      }
                      <span class="resource-card__meter" aria-hidden="true">
                        <span [style.width.%]="libraryMeter(base)"></span>
                      </span>
                    </button>
                  }
                }
              </div>
            </div>
          </section>
        }

        @case ('tools') {
          <section class="builder-scene">
            <header class="scene-heading scene-heading--compact">
              <h1>Ferramentas</h1>
              <p>Integrações, tools e políticas.</p>
            </header>

            <div class="tools-layout">
              <div class="tools-catalog-column">
                <section appUiPanelCard class="surface-panel tools-section">
                  <app-ui-section-header
                    label="Integrações conectadas"
                    help="Escolha quais conexões entram no escopo operacional deste agente."
                  />
                  <div class="catalog-toolbar">
                    <label class="search-field">
                      <ng-icon name="heroMagnifyingGlass" size="16" aria-hidden="true" />
                      <input
                        appInput
                        type="search"
                        placeholder="Buscar integração"
                        [value]="store.integrationSearch()"
                        (input)="store.setString(store.integrationSearch, $event)"
                      />
                    </label>
                    <button
                      appButton
                      variant="primary"
                      type="button"
                      (click)="openProvider(providerCatalog[0])"
                    >
                      <ng-icon name="heroPlus" size="16" aria-hidden="true" />
                      Nova integração
                    </button>
                  </div>

                  <div class="integration-grid">
                    @if (store.visibleIntegrations().length === 0) {
                      <app-ui-empty-state
                        class="col-span-full"
                        icon="heroBolt"
                        title="Nenhuma integra&ccedil;&atilde;o encontrada"
                        description="Ajuste a busca ou conecte uma nova integra&ccedil;&atilde;o."
                      />
                    } @else {
                      @for (integration of store.visibleIntegrations(); track integration.id) {
                        <button
                          type="button"
                          appUiOptionRow
                          class="integration-card"
                          [selected]="
                            store.isSelected(store.selectedIntegrationIds(), integration.id)
                          "
                          (click)="store.toggleIntegration(integration.id)"
                        >
                          <app-provider-brand-icon
                            [entry]="providerEntryForIntegration(integration.provider)"
                            [size]="2.1"
                          />
                          <span>
                            <strong>{{ integration.displayName }}</strong>
                            <small
                              >{{
                                providerEntryForIntegration(integration.provider)?.name ||
                                  integration.provider
                              }}
                              · {{ store.integrationStatusLabel(integration.status) }}</small
                            >
                          </span>
                          @if (store.isSelected(store.selectedIntegrationIds(), integration.id)) {
                            <ng-icon name="heroCheck" size="16" aria-hidden="true" />
                          }
                        </button>
                      }
                    }
                  </div>
                </section>

                <section appUiPanelCard class="surface-panel tools-section tools-section--list">
                  <app-ui-section-header
                    label="Tools disponíveis"
                    help="Ative somente as capacidades que a missão pode chamar."
                  />
                  <div class="tools-controls">
                  <div class="catalog-toolbar">
                    <label class="search-field">
                      <ng-icon name="heroMagnifyingGlass" size="16" aria-hidden="true" />
                      <input
                        appInput
                        type="search"
                        placeholder="Filtrar ferramentas"
                        [value]="store.toolSearch()"
                        (input)="store.setString(store.toolSearch, $event)"
                      />
                    </label>
                    <span appBadge tone="accent" size="sm">{{ selectedToolLabel() }}</span>
                  </div>

                  @if (store.hasAgentBindings()) {
                    <details class="agent-bindings-panel">
                      <summary class="agent-bindings-panel__summary">
                        <ng-icon
                          name="heroChevronRight"
                          size="16"
                          aria-hidden="true"
                          class="agent-bindings-panel__chevron"
                        />
                        <span>Agendamento do agente</span>
                      </summary>
                      <div class="agent-bindings-panel__body">
                      <p class="agent-bindings-panel__hint">
                        Configure uma vez para o agente — todas as ferramentas de calendário usam estes valores.
                      </p>
                      <app-ui-form-field
                        label="Visibilidade da agenda"
                        hint="Interno: o agente vê todos os eventos. Cliente: vê só os do próprio contato; os demais horários aparecem apenas como ocupados."
                      >
                        <button
                          appSelect
                          type="button"
                          [ngpSelectValue]="store.agendaVisibility()"
                          (ngpSelectValueChange)="store.setAgendaVisibility($event)"
                          aria-label="Visibilidade da agenda"
                        >
                          <span>{{ store.agendaVisibilityLabel() }}</span>
                          <div *ngpSelectPortal appSelectDropdown>
                            <div appSelectOption [ngpSelectOptionValue]="'client'"><span>Cliente — vê só os próprios</span></div>
                            <div appSelectOption [ngpSelectOptionValue]="'internal'"><span>Interno — vê todos os eventos</span></div>
                          </div>
                        </button>
                      </app-ui-form-field>
                      @for (descriptor of store.agentBindingDescriptors(); track descriptor.key) {
                        <app-ui-form-field [label]="descriptor.label">
                          @if (store.bindDescriptorOptions(descriptor).length === 0) {
                            @if (descriptor.optionsFrom === 'business_hours_calendars') {
                              <p class="agent-bindings-panel__empty">
                                Nenhum horário de funcionamento configurado. Crie um em
                                <a appButton variant="ghost" size="sm" routerLink="/configuracoes">Configurações</a>.
                              </p>
                            } @else {
                              <p class="agent-bindings-panel__empty">
                                Nenhuma agenda conectada. Conecte uma em
                                <a appButton variant="ghost" size="sm" routerLink="/integracoes">Integrações</a>.
                              </p>
                            }
                          } @else {
                            <button
                              appSelect
                              type="button"
                              [ngpSelectValue]="store.agentBindingValue(descriptor.key)"
                              (ngpSelectValueChange)="store.setAgentBinding(descriptor.key, $event)"
                              [attr.aria-label]="descriptor.label"
                            >
                              <span>{{ store.bindDescriptorSelectedLabel(descriptor) || '— Selecione —' }}</span>
                              <div *ngpSelectPortal appSelectDropdown>
                                @for (option of store.bindDescriptorOptions(descriptor); track option.value) {
                                  <div appSelectOption [ngpSelectOptionValue]="option.value">
                                    <span>{{ option.label }}</span>
                                  </div>
                                }
                              </div>
                            </button>
                          }
                        </app-ui-form-field>
                      }
                      @if (store.hasEventTemplateConfig()) {
                        <app-ui-form-field
                          label="Título padrão do evento"
                          hint="Use {nome} para inserir o nome do contato automaticamente. Ex.: Consulta - {nome}"
                        >
                          <input
                            appInput
                            type="text"
                            placeholder="Ex.: Consulta - {nome}"
                            [value]="store.eventTitleDefault()"
                            (input)="store.setEventTitleDefault($event)"
                          />
                        </app-ui-form-field>
                        <app-ui-form-field label="Duração padrão (minutos)">
                          <input
                            appInput
                            type="number"
                            min="1"
                            placeholder="Ex.: 30"
                            [value]="store.eventDurationMinutes() ?? ''"
                            (input)="store.setEventDurationMinutes($event)"
                          />
                        </app-ui-form-field>
                      }
                      </div>
                    </details>
                  }
                  </div>

                  <div class="tool-grid">
                    @if (store.visibleTools().length === 0) {
                      <app-ui-empty-state
                        class="col-span-full"
                        icon="heroWrenchScrewdriver"
                        title="Nenhuma ferramenta dispon&iacute;vel"
                        description="Selecione integra&ccedil;&otilde;es compat&iacute;veis ou avance sem ferramentas."
                      />
                    } @else {
                      @for (tool of store.visibleTools(); track tool.id) {
                        <article
                          appUiRecordRow
                          [interactive]="false"
                          [selected]="store.isSelected(store.selectedToolIds(), tool.id)"
                          class="tool-card"
                        >
                          <header>
                            <span class="tool-card__icon">
                              <ng-icon name="heroWrenchScrewdriver" size="17" aria-hidden="true" />
                            </span>
                            <span>
                              <strong>{{ tool.displayName || tool.key }}</strong>
                              <small
                                >{{ tool.owningDomain }} ·
                                {{ store.toolRiskLabel(tool.riskLevel) }}</small
                              >
                            </span>
                            <button
                              appSwitch
                              type="button"
                              [ngpSwitchChecked]="
                                store.isSelected(store.selectedToolIds(), tool.id)
                              "
                              (ngpSwitchCheckedChange)="store.toggleTool(tool.id)"
                              [attr.aria-label]="'Alternar ' + (tool.displayName || tool.key)"
                            >
                              <span appSwitchThumb></span>
                            </button>
                          </header>
                          <p>{{ tool.description }}</p>
                        </article>
                      }
                    }
                  </div>
                </section>
              </div>

              <app-agent-tool-config-panel class="tool-config-rail" />
            </div>
          </section>
        }

        @case ('mission') {
          <section class="builder-scene builder-scene--wide">
            <header class="scene-heading scene-heading--compact">
              <h1>Missão</h1>
              <p>Documento único de revisão.</p>
            </header>
            <app-agent-mission-editor-step />
          </section>
        }

        @case ('deployments') {
          <section class="builder-scene">
            <header class="scene-heading scene-heading--compact">
              <h1>Deployments</h1>
              <p>Contas, versão, execução e gatilhos.</p>
            </header>

            <div class="deployment-layout">
              <section appUiPanelCard class="deployment-command" aria-label="Resumo de publicação">
                <div class="deployment-command__copy">
                  <span appBadge [tone]="deploymentReviewTone()" size="sm">{{
                    deploymentReviewLabel()
                  }}</span>
                  <strong>{{ deploymentReadinessTitle() }}</strong>
                  <p>{{ deploymentReadinessDetail() }}</p>
                </div>

                <div class="deployment-signal-list" aria-label="Pontos de revisão">
                  @for (item of deploymentReviewItems(); track item.label) {
                    <article appUiPanelCard class="deployment-signal">
                      <span>{{ item.label }}</span>
                      <strong>{{ item.value }}</strong>
                    </article>
                  }
                </div>
              </section>

              <section appUiPanelCard class="surface-panel deployment-control-panel">
                <app-ui-section-header
                  label="Política operacional"
                  help="Defina o modo de execução, o estado inicial e como a versão será resolvida em produção."
                />

                <div class="deployment-controls">
                  <div appUiPanelCard class="field-block">
                    <span appUiLabel class="mb-1 block uppercase">Modo</span>
                    <button
                      appSelect
                      type="button"
                      [ngpSelectValue]="store.deploymentMode()"
                      (ngpSelectValueChange)="store.setDeploymentMode($event)"
                    >
                      {{ store.deploymentModeLabel() }}
                      <div *ngpSelectPortal appSelectDropdown>
                        @for (option of store.deploymentModeOptions; track option.value) {
                          <div appSelectOption [ngpSelectOptionValue]="option.value">
                            {{ option.label }}
                          </div>
                        }
                      </div>
                    </button>
                    <small>{{ deploymentModeDetail() }}</small>
                  </div>
                  <div appUiPanelCard class="field-block">
                    <span appUiLabel class="mb-1 block uppercase">Estado</span>
                    <button
                      appSelect
                      type="button"
                      [ngpSelectValue]="store.deploymentStatus()"
                      (ngpSelectValueChange)="store.setDeploymentStatus($event)"
                    >
                      {{ store.deploymentStatusLabel() }}
                      <div *ngpSelectPortal appSelectDropdown>
                        @for (option of store.deploymentStatusOptions; track option.value) {
                          <div appSelectOption [ngpSelectOptionValue]="option.value">
                            {{ option.label }}
                          </div>
                        }
                      </div>
                    </button>
                    <small>{{ deploymentStatusDetail() }}</small>
                  </div>
                  <div appUiPanelCard class="field-block">
                    <span appUiLabel class="mb-1 block uppercase">Versão</span>
                    <button
                      appSelect
                      type="button"
                      [ngpSelectValue]="store.versionResolution()"
                      (ngpSelectValueChange)="store.setVersionResolution($event)"
                    >
                      {{ store.versionResolutionLabel() }}
                      <div *ngpSelectPortal appSelectDropdown>
                        @for (option of store.versionResolutionOptions; track option.value) {
                          <div appSelectOption [ngpSelectOptionValue]="option.value">
                            {{ option.label }}
                          </div>
                        }
                      </div>
                    </button>
                    <small>{{ versionResolutionDetail() }}</small>
                  </div>
                </div>
              </section>

              <section appUiPanelCard class="surface-panel deployment-channel-panel">
                <app-ui-section-header
                  label="Escopo de atendimento"
                  help="Escolha as contas onde o agente pode operar. Credenciais e conexão continuam em Integrações."
                >
                  <span
                    sectionActions
                    appBadge
                    [tone]="store.selectedChannelAccounts().length ? 'accent' : 'warning'"
                    size="sm"
                  >
                    {{ store.selectedChannelAccounts().length }} conta(s)
                  </span>
                </app-ui-section-header>

                <div class="deployment-grid">
                  @if (store.selectedAllowedChannels().length === 0) {
                    <app-ui-empty-state
                      class="col-span-full"
                      icon="heroRocketLaunch"
                      title="Nenhum canal selecionado"
                      description="Selecione pelo menos um canal em Contexto para configurar deployments."
                    />
                  } @else {
                    @for (channel of store.selectedAllowedChannels(); track channel.type) {
                      <article appUiPanelCard class="deployment-card" [style.--channel-color]="channel.brandColor">
                        <header>
                          <span class="channel-card__brand">
                            <img [ngSrc]="channel.logoColorPath" width="22" height="22" alt="" />
                          </span>
                          <span>
                            <strong>{{ channel.label }}</strong>
                            <small>{{ channelDeploymentSummary(channel.type) }}</small>
                          </span>
                          <span
                            appBadge
                            [tone]="selectedAccountCountForChannel(channel.type) ? 'accent' : 'warning'"
                            size="xs"
                          >
                            {{ selectedAccountCountForChannel(channel.type) }} selecionada(s)
                          </span>
                        </header>

                        @if (store.channelAccountsForType(channel.type).length === 0) {
                          <p appUiEmptyText>Conecte uma conta para ativar este canal.</p>
                        } @else {
                          <div class="account-choice-list">
                            @for (
                              account of store.channelAccountsForType(channel.type);
                              track account.id
                            ) {
                        <button
                          type="button"
                          appUiOptionRow
                          class="account-choice"
                          [selected]="
                            store.isSelected(store.selectedChannelAccountIds(), account.id)
                          "
                                (click)="store.toggleChannelAccount(account.id)"
                                [attr.aria-pressed]="
                                  store.isSelected(store.selectedChannelAccountIds(), account.id)
                                "
                              >
                                <span>
                                  <strong>{{ account.label }}</strong>
                                  <small>{{ store.channelLabel(account.kind) }}</small>
                                </span>
                                <span class="account-choice__state">
                                  @if (
                                    store.isSelected(store.selectedChannelAccountIds(), account.id)
                                  ) {
                                    <span appBadge tone="accent" size="xs">Selecionada</span>
                                    <ng-icon name="heroCheck" size="16" aria-hidden="true" />
                                  } @else {
                                    <span appBadge tone="neutral" size="xs">Fora</span>
                                  }
                                </span>
                              </button>
                              @if (store.isSelected(store.selectedChannelAccountIds(), account.id)) {
                                <div appUiPanelCard class="deployment-segment-control">
                                  <label>
                                    <span>Atendimento</span>
                                    <select
                                      appNativeSelect
                                      [value]="store.deploymentSegmentForAccount(account.id)"
                                      (change)="store.setDeploymentSegmentForAccount(account.id, $any($event.target).value)"
                                    >
                                      <option value="">Atender todos os contatos</option>
                                      @for (segment of store.contactSegments(); track segment.id) {
                                        <option [value]="segment.id">Atender somente {{ segment.name }}</option>
                                      }
                                    </select>
                                  </label>
                                  <small>{{ store.deploymentSegmentSummary(account.id) }}</small>
                                </div>
                                <div appUiPanelCard class="deployment-account-controls">
                                  <label>
                                    <span>Estado</span>
                                    <select
                                      appNativeSelect
                                      [value]="store.deploymentStatusForAccount(account.id)"
                                      (change)="store.setDeploymentStatusForAccount(account.id, $any($event.target).value)"
                                    >
                                      @for (option of store.deploymentStatusOptions; track option.value) {
                                        <option [value]="option.value">{{ option.label }}</option>
                                      }
                                    </select>
                                  </label>

                                  <label>
                                    <span>Modo</span>
                                    <select
                                      appNativeSelect
                                      [value]="store.deploymentModeForAccount(account.id)"
                                      (change)="store.setDeploymentModeForAccount(account.id, $any($event.target).value)"
                                    >
                                      @for (option of store.deploymentModeOptions; track option.value) {
                                        <option [value]="option.value">{{ option.label }}</option>
                                      }
                                    </select>
                                  </label>

                                  <label>
                                    <span>Versão</span>
                                    <select
                                      appNativeSelect
                                      [value]="store.deploymentVersionResolutionForAccount(account.id)"
                                      (change)="store.setDeploymentVersionResolutionForAccount(account.id, $any($event.target).value)"
                                    >
                                      @for (option of store.versionResolutionOptions; track option.value) {
                                        <option [value]="option.value">{{ option.label }}</option>
                                      }
                                    </select>
                                  </label>

                                  @if (store.deploymentVersionResolutionForAccount(account.id) === 'fixed_agent_version') {
                                    <label>
                                      <span>Versão publicada</span>
                                      <select
                                        appNativeSelect
                                        [value]="store.deploymentAgentVersionForAccount(account.id)"
                                        (change)="store.setDeploymentAgentVersionForAccount(account.id, $any($event.target).value)"
                                      >
                                        <option value="">Escolha uma versão</option>
                                        @for (version of store.publishedVersions(); track version.id) {
                                          <option [value]="version.id">v{{ version.version }} · política do arquétipo</option>
                                        }
                                      </select>
                                    </label>
                                  }
                                  <small>{{ store.deploymentVersionSummary(account.id) }}</small>
                                </div>
                              }
                            }
                          </div>
                        }

                        <details class="channel-policy">
                          <summary appUiPanelCard>
                            <span>
                              <strong>Políticas do canal</strong>
                              <small>{{ channelPolicySummary(channel.type) }}</small>
                            </span>
                          </summary>

                          <div class="channel-policy__grid">
                            <div class="policy-control">
                              <span appUiLabel class="mb-1 block uppercase">Detalhamento</span>
                              <button
                                appSelect
                                type="button"
                                [ngpSelectValue]="
                                  store.channelBehaviors()[channel.type].messageLength
                                "
                                (ngpSelectValueChange)="
                                  store.setChannelMessageLengthFromSelect(channel.type, $event)
                                "
                              >
                                {{
                                  store.messageLengthLabel(
                                    store.channelBehaviors()[channel.type].messageLength
                                  )
                                }}
                                <div *ngpSelectPortal appSelectDropdown>
                                  @for (option of messageLengthOptions; track option.value) {
                                    <div appSelectOption [ngpSelectOptionValue]="option.value">
                                      {{ option.label }}
                                    </div>
                                  }
                                </div>
                              </button>
                            </div>

                            <label class="policy-control policy-control--wide">
                              <span appUiLabel class="mb-1 block uppercase">Estilo</span>
                              <textarea
                                appTextarea
                                rows="2"
                                [value]="store.channelBehaviors()[channel.type].toneStyle"
                                (input)="
                                  store.setChannelBehaviorText(channel.type, 'toneStyle', $event)
                                "
                              ></textarea>
                            </label>

                            <label class="policy-control">
                              <span appUiLabel class="mb-1 block uppercase">Templates</span>
                              <textarea
                                appTextarea
                                rows="2"
                                [value]="store.channelBehaviors()[channel.type].templatePolicy"
                                (input)="
                                  store.setChannelBehaviorText(
                                    channel.type,
                                    'templatePolicy',
                                    $event
                                  )
                                "
                              ></textarea>
                            </label>

                            <label class="policy-control">
                              <span appUiLabel class="mb-1 block uppercase">Mídia</span>
                              <textarea
                                appTextarea
                                rows="2"
                                [value]="store.channelBehaviors()[channel.type].mediaPolicy"
                                (input)="
                                  store.setChannelBehaviorText(channel.type, 'mediaPolicy', $event)
                                "
                              ></textarea>
                            </label>

                            <label class="policy-control">
                              <span appUiLabel class="mb-1 block uppercase">Janela</span>
                              <textarea
                                appTextarea
                                rows="2"
                                [value]="store.channelBehaviors()[channel.type].asyncWindowPolicy"
                                (input)="
                                  store.setChannelBehaviorText(
                                    channel.type,
                                    'asyncWindowPolicy',
                                    $event
                                  )
                                "
                              ></textarea>
                            </label>

                            <label class="policy-control">
                              <span appUiLabel class="mb-1 block uppercase">Fallback</span>
                              <textarea
                                appTextarea
                                rows="2"
                                [value]="store.channelBehaviors()[channel.type].fallbackPolicy"
                                (input)="
                                  store.setChannelBehaviorText(
                                    channel.type,
                                    'fallbackPolicy',
                                    $event
                                  )
                                "
                              ></textarea>
                            </label>
                          </div>
                        </details>
                      </article>
                    }
                  }
                </div>
              </section>

              <section appUiPanelCard class="surface-panel trigger-panel">
                <app-ui-section-header
                  label="Automações acionadas"
                  help="Gatilhos aceitos ficam vinculados ao deployment; sugestões precisam ser revisadas antes de publicar."
                >
                  <span sectionActions appBadge tone="neutral" size="sm">
                    {{ acceptedTriggerDrafts().length }} aceito(s)
                  </span>
                </app-ui-section-header>

                <div class="trigger-grid">
                  <div class="trigger-column">
                    <div class="section-title section-title--subtle">
                      <h2>Aceitas</h2>
                      <span>{{ acceptedTriggerDrafts().length }}</span>
                    </div>

                    @if (acceptedTriggerDrafts().length === 0) {
                      <div appUiEmptyText>Nenhuma automação será acionada.</div>
                    } @else {
                      <div class="accepted-trigger-list">
                        @for (draft of acceptedTriggerDrafts(); track draft.id) {
                          <article appUiRecordRow [interactive]="false" [selected]="true" class="accepted-trigger-row">
                            <span>
                              <strong>{{ draft.name }}</strong>
                              <small
                                >{{ triggerActionLabel(draft.action) }} ·
                                {{
                                  draft.mode === 'deterministic' ? 'determinístico' : 'semântico'
                                }}</small
                              >
                              <em>{{ draft.eventKey }}</em>
                            </span>
                            <button
                              appButton
                              variant="secondary"
                              size="sm"
                              type="button"
                              (click)="store.toggleTriggerAccepted(draft.id)"
                            >
                              Remover
                            </button>
                          </article>
                        }
                      </div>
                    }
                  </div>

                  <div class="trigger-column">
                    <div class="section-title section-title--subtle">
                      <h2>Sugestões</h2>
                      <span>{{ store.triggerSuggestions().length }}</span>
                    </div>

                    @if (store.triggerSuggestions().length === 0) {
                      <div appUiEmptyText>Sem sugestão disponível para a missão atual.</div>
                    } @else {
                      <div class="suggestion-list">
                        @for (suggestion of store.triggerSuggestions(); track suggestion.key) {
                          <article appUiRecordRow [interactive]="false" class="suggestion-row">
                            <span>
                              <strong>{{ suggestion.title }}</strong>
                              <small>{{ suggestion.notes[0] || suggestion.canonicalEvent }}</small>
                              <em>{{ suggestion.eventKey }}</em>
                            </span>
                            <button
                              appButton
                              variant="secondary"
                              size="sm"
                              type="button"
                              (click)="store.acceptSuggestion(suggestion)"
                              [disabled]="isSuggestionAccepted(suggestion.key)"
                            >
                              {{ isSuggestionAccepted(suggestion.key) ? 'Aceito' : 'Aceitar' }}
                            </button>
                          </article>
                        }
                      </div>
                    }
                  </div>
                </div>
              </section>
            </div>
          </section>
        }
      }
    }
    }
  </section>

  @if (!store.loading() && !isEmbeddedEdit() && (isEditShell() || store.activeStep() === 'mission')) {
    @if (store.activeStep() === 'mission' && store.publishBlockers().length > 0) {
      <div appUiPanelCard class="publish-blockers" role="status">
        @for (blocker of store.publishBlockers(); track blocker) {
          <span>{{ blocker }}</span>
        }
      </div>
    }
    <nav class="bottom-nav" aria-label="Navegação inferior">
      @if (isEditShell()) {
        @if (activeEditTab() === 'deployments') {
          <button
            appButton
            variant="secondary"
            type="button"
            (click)="store.publish()"
            [disabled]="!store.canPublish() || store.saving()"
          >
            <ng-icon name="heroRocketLaunch" size="16" aria-hidden="true" />
            Publicar versão
          </button>
          <button
            appButton
            variant="primary"
            type="button"
            (click)="saveDeployments()"
            [disabled]="store.saving() || (!store.deploymentDirty() && !store.triggerDirty())"
          >
            Salvar deployments
          </button>
        } @else if (activeEditTab() === 'missao' || activeEditTab() === 'configuracao') {
          <button appButton variant="secondary" type="button" (click)="saveDraft()" [disabled]="store.saving()">
            Salvar rascunho
          </button>
          <button appButton variant="primary" type="button" (click)="store.publish()" [disabled]="!store.canPublish()">
            <ng-icon name="heroRocketLaunch" size="16" aria-hidden="true" />
            Publicar versão
          </button>
        }
      } @else {
      <button
        appButton
        variant="secondary"
        type="button"
        (click)="returnToAssistantReview()"
      >
        Voltar para revis&atilde;o
      </button>
      <button
        appButton
        variant="primary"
        type="button"
        (click)="store.activeStep() === 'mission' ? store.publish() : store.next()"
        [disabled]="
          store.activeStep() === 'mission' ? !store.canPublish() : !store.canContinue()
        "
      >
        @if (store.activeStep() === 'mission') {
          @if (store.publishing()) {
            Publicando...
          } @else {
            <ng-icon name="heroRocketLaunch" size="16" aria-hidden="true" />
            Publicar versão
          }
        } @else {
          Continuar
          <ng-icon name="heroArrowRight" size="16" aria-hidden="true" />
        }
      </button>
      }
    </nav>
  }

  @if (selectedProviderEntry(); as entry) {
    <app-connect-dialog [entry]="entry" (closed)="closeProvider()" (done)="onConnectDone($event)" />
  }
</main>
